import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "fill-height absolute w-full" }
const _hoisted_2 = {
  key: 0,
  class: "overlay"
}
const _hoisted_3 = { class: "text-medium-emphasis font-weight-bold text-h6" }
const _hoisted_4 = {
  key: 0,
  class: "text-subtitle-2 text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: _normalizeClass(["d-flex flex-column default_card elevation-0 fill-height mx-2", { 'cursor-default': !_ctx.dense }]),
      id: "card",
      outlined: _ctx.dense,
      "rounded-xl": "",
      disabled: _ctx.comingSoon,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dense ? (_ctx.openDialog = _ctx.dense) : null))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "px-2 mb-auto fill-height" }, {
          default: _withCtx(() => [
            (_ctx.comingSoon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "font-weight-black title" }, "Bientôt disponible", -1)
                ])))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "fill-height"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          class: _normalizeClass({
                                    'z-1': _ctx.comingSoon,
                                })
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
                            (_ctx.partnerName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.partnerName), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.logo)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              class: _normalizeClass({
                                    'd-flex justify-end pr-3 py-0': true,
                                    'z-1': _ctx.comingSoon,
                                })
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_img, {
                                  height: "50px",
                                  width: "50px",
                                  contain: "",
                                  src: _ctx.logo
                                }, null, 8, ["src"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (!_ctx.dense)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12",
                              class: "pt-5 text-medium-emphasis"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.text), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.$slots['sub-text'])
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "pt-5 mt-auto"
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "sub-text", {}, undefined, true)
                      ]),
                      _: 3
                    }))
                  : _createCommentVNode("", true),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      class: "pt-5 text-red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ]),
          _: 3
        }),
        (!_ctx.dense)
          ? (_openBlock(), _createBlock(_component_v_card_actions, {
              key: 0,
              class: "py-0",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "pb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "d-flex align-center mb-0 py-0"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.displayConfiguration)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              class: "px-4",
                              id: "config",
                              size: "small",
                              variant: "flat",
                              dark: "",
                              disabled: _ctx.activeReadonly || _ctx.comingSoon,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDialog = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.settingBtnTitle || "Configurer"), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "d-flex justify-end"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.displayActiveSwitch)
                          ? (_openBlock(), _createBlock(_component_v_switch, {
                              key: 0,
                              id: "switch",
                              class: "mt-0",
                              onClick: _ctx.onActive,
                              readonly: _ctx.activeReadonly || _ctx.comingSoon,
                              "hide-details": "",
                              "model-value": _ctx.activeSwitch
                            }, null, 8, ["onClick", "readonly", "model-value"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_oss_dialog, _mergeProps({
            modelValue: _ctx.openDialog,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openDialog) = $event)),
            title: _ctx.title,
            minWidth: _ctx.width,
            onValid: _ctx.valid,
            onClose: _ctx.closeDialog,
            onPrevious: _ctx.previousDialog
          }, _ctx.dialogBind_, {
            actions: _ctx.actions,
            previousDisplay: !_ctx.hidePrevious,
            previousDisabled: _ctx.hidePrevious,
            hideValid: _ctx.hideValid
          }), {
            after: _withCtx(() => [
              (!_ctx.hideMoreVert)
                ? (_openBlock(), _createBlock(_component_v_menu, {
                    key: 0,
                    "offset-y": ""
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          (_ctx.displayDeleteBtn)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: _ctx.handleDelete,
                                title: "Supprimer"
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: "$oss-trash",
                                    size: "small"
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          }, 16, ["modelValue", "title", "minWidth", "onValid", "onClose", "onPrevious", "actions", "previousDisplay", "previousDisabled", "hideValid"])
        ])
      ]),
      _: 3
    }, 8, ["class", "outlined", "disabled"])
  ]))
}